import darkMode from './darkMode';
import { TRANSIT_DOMAIN } from '../utils/config';
export default {
  mixins: [darkMode],
  computed: {
    swapUrl() {
      if (process.env.VUE_APP_ENV !== 'production') {
        return `https://test-tp1.tokenpocket.pro/dev/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/`;
      } else {
        return `https://swap.transit.finance/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/`;
      }
    },
    swapMarketUrl() {
      if (process.env.VUE_APP_ENV !== 'production') {      
        return `https://test-tp1.tokenpocket.pro/dev/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/market`;
      } else {
        return `https://swap.transit.finance/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/market`;
      }
    },
    transitBuyUrl() {
      return `https://buy.transit.finance/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}`
    },
    transitExplorerUrl() {
      return `https://explorer.transit.finance/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}`
    },
    transitBridgeUrl() {
      const query = `inputChain=ETH&inputSymbol=ETH&outputChain=BSC&outputSymbol=BNB&market=0#/`
      return `${TRANSIT_DOMAIN}?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}&${query}`
    },
    transitAdvancedUrl() {
      const query = `inputChain=ETH&inputSymbol=ETH&outputChain=ETH&outputCurrency=0xdac17f958d2ee523a2206206994597c13d831ec7&outputSymbol=USDT&market=1#/`
      return `${TRANSIT_DOMAIN}?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}&${query}`
    },
  },
};
